var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"theme-alert theme-alert--large theme-alert--notification",attrs:{"data-push-panel":""}},[_c('div',{staticClass:"theme-alert__text"},[_vm._t("default"),_vm._v(" "),_c('div',[_vm._t("action")],2)],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }